import { render, staticRenderFns } from "./SendCode.vue?vue&type=template&id=d512efae&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "@/scss/login.scss?vue&type=style&index=0&id=d512efae&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d512efae",
  null
  
)

export default component.exports